import { render, staticRenderFns } from "./V2ConfirmationModal.vue?vue&type=template&id=c1f21d04&scoped=true&"
import script from "./V2ConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./V2ConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./V2ConfirmationModal.vue?vue&type=style&index=0&id=c1f21d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f21d04",
  null
  
)

export default component.exports